import React from 'react'

export default function Plus({ color }: { color: string }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 16H24M16 8V24" stroke={color} strokeWidth="2.665" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
